import moment from 'moment';
import Utils from 'utils';

export default function init($) {
    // Set moment's locale globally
    moment.locale('lv');

    // Prevent the backspace key from navigating back.
    const keyDownFn = function keyDownFn(event) {
        let doPrevent = false;
        if (event.keyCode === 8) {
            const d = event.srcElement || event.target;
            if (d.tagName.toUpperCase() === 'INPUT' || d.tagName.toUpperCase() === 'TEXTAREA') {
                doPrevent = false;
            } else {
                doPrevent = true;
            }
        }

        if (doPrevent) {
            event.preventDefault();
        }
    };
    $(document).on('keydown', keyDownFn);

    // Select element by id given in location.hash
    const hash = window.location.hash.replace('#', '');
    if (hash.indexOf('select-') === 0) {
        const id = hash.replace('select-', '');
        const row = $(`#${id}`);
        row.addClass('info');

        $('html,body').animate(
            {
                scrollTop: row.offset().top - 100
            },
            700
        );
    }

    // Global company selector
    $('#global_company_selector').on('click', '.dropdown-item', function evnt(e) {
        e.preventDefault();
        const companyId = $(this).data('id');
        $.post(`${BASE_URL}companies/manage/select-company/${companyId}`, (responseData) => {
            if (responseData.msg) {
                Utils.showAlert('Kļūda', responseData.msg.text);
                return;
            }

            window.location.reload();
        });
    });

    /*
    // Custom error handler
    window.onerror = function(errorMsg, url, lineNumber, column, errorObj) {
        $.post('/defaults/settings/js-error', {
            'pageUrl': location.href,
            'errorMsg': errorMsg,
            'url': url,
            'lineNumber': lineNumber,
            'column': column,
            'errorObj': errorObj,
            'userAgent': navigator.userAgent
        });
    }
    */
}

export function initJQuery($) {
    // Set default ajax options
    $.ajaxSetup({
        dataType: 'json',
        error() {
            Utils.showAlert('Error', 'Request to the server resulted in an error', 'danger');
        }
    });
}
